import React from 'react';

import axios from 'axios';

export const useRemoteDepositPaymentLinkActions = (saleID: number = 0) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  if (saleID === 0) {
    return null;
  }

  const editCurrentRemoteDepositPaymentRequest = () =>
    window.merchantos.register.account_actions.deposit();

  const removeCurrentRemoteDepositPaymentRequest = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      await axios.delete(`/admin/sale/${saleID}/remote-deposit`);
    } catch (error) {
      setIsError(true);
      window.alertUser('Something went wrong. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const addRemoteDepositPaymentRequest = async (depositAmount: string, sendReceipt?: boolean) => {
    setIsLoading(true);
    setIsError(false);
    let previousDeposit = 0;
    let totalDeposit: string | number;

    /**
     *  This logic below is used to check if there is an element in the DOM that matches the same ID
     *  This ID is only found when the edit click event from PaymentLinkDepositTile.tsx fires, and causes the tile element class to update.
     *  If the element is in the DOM we know an edit taking place, we will overwrite the value in the payment tile.
     *  If the element is not found we will treat the input value as an addition to the existing amount displayed in the payment tile.
     */

    const el = document.getElementById('remote-payment-deposit-tile-editing');

    if (el) {
      totalDeposit = depositAmount;
    } else {
      try {
        const response = await axios.get(`/admin/sale/${saleID}/remote-deposit`);
        previousDeposit = parseFloat(response.data.data.amount);
      } catch (error) {
        /**
         * the get call will return 404 if there is an error with the endpoint,
         * or there is no in-person deposit currently, and the error is handled in the React component that calls this function.
         */
      }

      totalDeposit = previousDeposit + parseFloat(depositAmount);
    }

    try {
      await axios.post(`/admin/sale/${saleID}/remote-deposit`, {
        amount: totalDeposit,
        sendReceipt: sendReceipt || false,
      });
    } catch (err) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addRemoteDepositPaymentRequest,
    removeCurrentRemoteDepositPaymentRequest,
    editCurrentRemoteDepositPaymentRequest,
    isLoading,
    isError,
  };
};
